import React, { useState, useEffect } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import './style.css';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import service from '../../services/service';
import LoadingOverlay from '../loading/loading';

const RoomSection = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const [activeTab] = useState('1');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchHotels();
    }, []);

    const fetchHotels = async () => {
        setLoading(true);
        try {
            const response = await service.view('hotels/list');
            if (response && !response.success) {
                toast.error(`${response.message}: ${response.error}`);
                return;
            } else if (response && response.success) {
                setData(response.data.hotels);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    // Calculate indices for pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

    // Generate page numbers
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <section className={`Room-area ${props.rClass}`} style={{ marginBottom: '100px' }}>
            {loading && <LoadingOverlay />}
            <div className="Room-section">
                <div className="container">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <h2>Discover Our Hotels</h2>
                        </div>
                    </div>
                    {data.length > 0 ? (
                        <div className="row">
                            <div className="col col-xs-12 sortable-gallery">
                                <div className="gallery-container">
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            {currentData.map((room, index) => (
                                                <div className="grid" key={index}>
                                                    <div className="room-item">
                                                        {room?.images && room.images.length > 0 && (
                                                            <img
                                                                style={{ width: '370px', height: '439px', objectFit: 'cover' }}
                                                                src={room.images[0]}
                                                                alt={room?.name}
                                                                className="img img-responsive"
                                                            />
                                                        )}
                                                        <div className="room-text-show"><h2>{room.name}</h2></div>
                                                        <div className="room-text-hide">
                                                            <h2>{room.name}</h2>
                                                            <span>📍{room.address}</span>
                                                            <small>🏨
                                                                {room.amenities.length > 0 ? room.amenities.join(", ") : "Not available"}
                                                            </small>
                                                            <small><span>₹ {room.pricePerNight}</span> / Night</small>
                                                            <Link className="theme-btn-s2" to={`/room-single/${room._id}`}>
                                                                Check Availability
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                            {/* Pagination Controls */}
                            <div className="pagination-container text-center">
                                <button
                                    className={`pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
                                    onClick={handlePrevious}
                                    disabled={currentPage === 1}
                                ><i className="fa fa-chevron-left"></i></button>
                                {pageNumbers.map((number) => (
                                    <button
                                        key={number}
                                        onClick={() => handlePageClick(number)}
                                        className={`pagination-btn ${number === currentPage ? 'active' : ''}`}
                                    >
                                        {number}
                                    </button>
                                ))}
                                <button
                                    className={`pagination-btn ${currentPage === totalPages ? 'disabled' : ''}`}
                                    onClick={handleNext}
                                    disabled={currentPage === totalPages}
                                ><i className="fa fa-chevron-right"></i></button>
                            </div>
                        </div>
                    ) : (
                        <div className="no-hotels-found">No hotels found!</div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default RoomSection;
